export const round = (value: number, digits: number) =>
{
    value = value * Math.pow(10, digits);
    value = Math.round(value);
    value = value / Math.pow(10, digits);
    return value;
};


// WEBPACK FOOTER //
// ./src/util/math.ts